import React, { useState, useEffect } from 'react';
import numeral from 'numeral';

const ProductPrice = ({ product, index = 0, onSelectChange }) => {
  const sortedPrices = [...(product.prices || [])].sort((a, b) => a.index - b.index);
  const [selectedIndex, setSelectedIndex] = useState(index || sortedPrices[0]?.index);

  useEffect(() => {
    setSelectedIndex(index || sortedPrices[0]?.index);
  }, [product]);

  useEffect(() => {
    if (onSelectChange && typeof onSelectChange === 'function') {
      onSelectChange(selectedIndex); // báo ra ngoài mỗi lần chọn
    }
  }, [selectedIndex]);

  const selectedPrice = sortedPrices.find(p => p.index === selectedIndex);

  return (
    <div>
      {/* Select styled */}
      {sortedPrices.length > 0 && (
        <select
          className='select-price'
          value={selectedIndex}
          onChange={(e) => setSelectedIndex(e.target.value)}
          style={{
            padding: '5px 5px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            // fontSize: '15px',
            margin: '0',
            cursor: 'pointer',
            backgroundColor: '#fdfdfd',
            color: '#222',
            outline: 'none',
            width: '100%',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#666'}
          onBlur={(e) => e.target.style.borderColor = '#ccc'}
        >
          {sortedPrices.map((priceOption) => (
            <option key={priceOption.index} value={priceOption.index}>
              {priceOption.name}
            </option>
          ))}
        </select>
      )}

      {/* Display price */}
      <div style={{ marginTop: '5px' }}>
        {(Number(selectedPrice?.price_new) > 0 &&
          Number(selectedPrice?.price_new) < Number(selectedPrice?.price)) ? (
          <div>
            <span style={{ color: 'red', fontWeight: 'bold', fontSize: '18px' }}>
              {numeral(selectedPrice.price_new).format('0,0')}₫
            </span>
            &nbsp;
            <span
              className="price-old"
              style={{
                textDecoration: 'line-through',
                color: '#888',
                fontSize: '16px',
              }}
            >
              {numeral(selectedPrice.price).format('0,0')}₫
            </span>
          </div>
        ) : (
          <div>
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              {numeral(selectedPrice?.price).format('0,0')}₫
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductPrice;